import { render, staticRenderFns } from "./conversation-actions.vue?vue&type=template&id=53159908"
import script from "./conversation-actions.vue?vue&type=script&lang=js"
export * from "./conversation-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports